import React from 'react';

import { MissingActionsDialog } from 'src/components/send-for-signature/components/sanity-check-modal/MissingActionsDialog';
import { AssignRolesDialog } from 'src/components/workflow/AssignRolesDialog';
import type { ReactSetStateTuple } from 'src/types';

import { UnusedActionsDialog } from './UnusedActionsDialog';

export type OpenDialogType = 'missing-actions' | 'unused-actions' | 'unassigned-roles';

interface SendSanityCheckModalProps {
  onClickFixMissingActions: (e: React.MouseEvent) => void;
  onClose: () => void;
  openDialogTuple: ReactSetStateTuple<OpenDialogType | null>;
  workflowId: UUID;
}

export function SanityCheckModal({
  onClickFixMissingActions,
  onClose,
  openDialogTuple: [openDialog],
  workflowId,
}: SendSanityCheckModalProps) {
  return (
    <>
      <MissingActionsDialog
        open={openDialog === 'missing-actions'}
        workflowId={workflowId}
        onClickFixIssue={onClickFixMissingActions}
        onClose={onClose}
      />
      <UnusedActionsDialog
        open={openDialog === 'unused-actions'}
        workflowId={workflowId}
        onClose={onClose}
      />
      <AssignRolesDialog
        open={openDialog === 'unassigned-roles'}
        title="Assign placeholders before sending"
        workflowId={workflowId}
        onClose={onClose}
      />
    </>
  );
}
